import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Badge } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';

import Tabs from '../Tabs';
import ControlSearchPanel from './ControlSearchPanel';
import GoBackBtn from '../buttons/GoBackBtn';
import AddButton from '../buttons/AddButton';
import useStyles from './styles';

const ControlHeader = ({
  showBack,
  title,
  badge,
  showAdd,
  showSearch,
  showTabs,
  showBadge,
  activeTab,
  onAdd,
  onSearch,
  overriddenClasses,
  goBackUrl,
}) => {
  const history = useHistory();
  const defaultClasses = useStyles();
  const [showBackdrop, setShowBackdrop] = useState(false);
  const [backdropHeight, setBackdropHeight] = useState('100%');
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const hasTabs = showTabs && (!isMobile || isMobile && showBackdrop);
  const classes = { ...defaultClasses, ...overriddenClasses };
  useLayoutEffect(() => {
    const handleScroll = () => {
      const body = document.body;
      const html = document.documentElement;
      const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      setBackdropHeight(`${docHeight - 195}px`)
    };
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGoBackBtnClick = () => {
    if (goBackUrl) {
      return history.push('/campaigns/');
    }
    return history.goBack();
  };
  
  return (
    <>
      {showTabs && isMobile && (
        <FontAwesomeIcon
          icon={faBars}
          onClick={() => setShowBackdrop(b => !b)}
          className={classes.menuIcon}
        />
      )}
      <div className={classnames(classes.tabs, { [classes.tabsOn]: hasTabs })}>
        {hasTabs && <Tabs activeTab={activeTab} />}
      </div>
      {showBack && <GoBackBtn onClick={handleGoBackBtnClick} />}
      <div className={classes.titlePart}>
        <h2 className={classes.title}>{title}</h2>
        {showBadge && <Badge pill className={classes.badge}>{badge}</Badge>}
        {showAdd && (
          <AddButton onClick={onAdd} className={classes.addBtn} />
        )}
      </div>
      {showSearch && (
        <ControlSearchPanel onSearch={onSearch} />
      )}
      <div
        className={classnames(classes.backdrop, {
          [classes.backdropOn]: showBackdrop
        })}
        style={{ height: showBackdrop ? backdropHeight : 0 }}
        onClick={() => setShowBackdrop(b => !b)}
      />
    </>
  );
};

ControlHeader.defaultProps = {
  showBack: false,
  title: '',
  badge: '',
  showAdd: false,
  showSearch: false,
  showTabs: false,
  showBadge: false,
  activeTab: '',
  onAdd: () => { },
  onSearch: () => { },
  goBackUrl: '',
};

ControlHeader.propTypes = {
  showBack: PropTypes.bool,
  title: PropTypes.string,
  badge: PropTypes.string,
  showAdd: PropTypes.bool,
  showSearch: PropTypes.bool,
  showTabs: PropTypes.bool,
  showBadge: PropTypes.bool,
  activeTab: PropTypes.string,
  onAdd: PropTypes.func,
  onSearch: PropTypes.func,
  goBackUrl: PropTypes.string,
};

export default ControlHeader;
